// How an agent conversation was entered (#3244); a notification entry re-reads a loaded stream.

export interface RouteEntry {
  source: "notification" | "navigation";
  messageId?: string;
}

const VIA = "via";
const NOTIFICATION = "notification";

// The route plus the entry marker, and `m` (the anchor the agent route focuses) if known.
export function notificationEntryUrl(path: string, messageId?: string): string {
  const url = new URL(path, "http://entry.invalid");
  url.searchParams.set(VIA, NOTIFICATION);
  if (messageId) url.searchParams.set("m", messageId);
  return `${url.pathname}${url.search}${url.hash}`;
}

// A mobile notification tap: an agent conversation it opens is entered as a notification.
export function notificationTapUrl(url: string): string {
  return /\/workspace\/[^/]+\/agent\/[^/?#]+/.test(url) ? notificationEntryUrl(url) : url;
}

export function routeEntryFromUrl(url: URL): RouteEntry {
  if (url.searchParams.get(VIA) !== NOTIFICATION) return { source: "navigation" };
  const messageId = url.searchParams.get("m");
  return messageId ? { source: NOTIFICATION, messageId } : { source: NOTIFICATION };
}

// The entry marker is read once: a reload or a shared link is not a notification.
export function withoutEntryMarker(url: URL): URL | null {
  if (!url.searchParams.has(VIA)) return null; // null: nothing to strip
  const next = new URL(url);
  next.searchParams.delete(VIA);
  return next;
}
